var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { CONFIG } from "../../config/app.config";
import { EProduct } from "../../config/app.config.types";
import { ECaptchaVersion, } from "../../types/auth.types";
import api from "../../utils/api/api.utils";
import { BASE_PATH_ENTITY } from "./auth.constants";
// The web sign-in forms solve a reCAPTCHA v2 checkbox; the API verifies it when it is sent.
var getCaptchaFields = function (captcha) {
    return captcha ? { captcha: captcha, captchaVersion: ECaptchaVersion.Legacy } : {};
};
export var signIn = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    var captcha, credentials, isInsuranceProduct, response_1, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                captcha = data.captcha, credentials = __rest(data, ["captcha"]);
                isInsuranceProduct = CONFIG.PRODUCT === EProduct.Insurance ||
                    CONFIG.PRODUCT === EProduct.InsuranceBackoffice;
                if (!isInsuranceProduct) return [3 /*break*/, 2];
                return [4 /*yield*/, api.post("/oauth/login", {
                        data: credentials,
                        authenticated: false,
                    })];
            case 1:
                response_1 = _a.sent();
                return [2 /*return*/, response_1.data];
            case 2: return [4 /*yield*/, api.post("/".concat(BASE_PATH_ENTITY, "/sign-in"), {
                    data: __assign(__assign({}, credentials), getCaptchaFields(captcha)),
                    isV2: true,
                    authenticated: false,
                })];
            case 3:
                response = _a.sent();
                return [2 /*return*/, response.data.data];
        }
    });
}); };
export var signInAutomatically = function (token, captcha) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api.post("/".concat(BASE_PATH_ENTITY, "/sign-in/token"), {
                    data: __assign({ token: token }, getCaptchaFields(captcha)),
                    isV2: true,
                    authenticated: false,
                })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.data.data];
        }
    });
}); };
// SSO lives outside the /auth path because it is its own resource on the API, so these two
// name the path in full rather than going through BASE_PATH_ENTITY.
var SSO_BASE_PATH_ENTITY = "sso";
/**
 * Which offices a work address can sign in to. Everyone shares one sign-in page, so this is
 * what turns what the person typed into a destination.
 *
 * An empty array means no office is configured for that domain — a normal answer the page
 * renders next to the field, not an error.
 */
export var discoverSsoConnections = function (emailOrDomain) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api.post("/".concat(SSO_BASE_PATH_ENTITY, "/discover"), {
                    data: { emailOrDomain: emailOrDomain },
                    isV2: true,
                    authenticated: false,
                })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.data.data];
        }
    });
}); };
/**
 * Where the browser is sent to start an office's SSO sign-in. A full navigation, not a fetch:
 * the API redirects to the identity provider and sets the cookie that binds the flow to this
 * browser, neither of which survives an XHR.
 *
 * The slug comes from the discovery call, never from the person: it names the connection in
 * the URLs the office registered with its identity provider, and is not something anyone is
 * expected to know or type.
 */
export var getSsoLoginUrl = function (slug) {
    return "".concat(CONFIG.BASE_URL_V2, "/").concat(SSO_BASE_PATH_ENTITY, "/").concat(encodeURIComponent(slug), "/login");
};
/**
 * Swaps the single-use code the callback was redirected with for a session.
 *
 * `withCredentials` is required, not incidental: the API refuses the exchange unless the
 * browser-binding cookie it set at the start of the flow comes back with the request.
 */
export var exchangeSsoCode = function (code) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api.post("/".concat(SSO_BASE_PATH_ENTITY, "/session"), {
                    data: { code: code },
                    isV2: true,
                    authenticated: false,
                    withCredentials: true,
                })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.data.data];
        }
    });
}); };
export var requestToken = function (userId) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api.post("/".concat(BASE_PATH_ENTITY, "/sign-in/request-token"), {
                    data: { userId: userId },
                    isV2: true,
                })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.data.data];
        }
    });
}); };
export var refreshAccessToken = function (refreshToken) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api.post("/".concat(BASE_PATH_ENTITY, "/token-refresh"), {
                    data: { refreshToken: refreshToken },
                    isV2: true,
                    authenticated: false,
                })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.data.data];
        }
    });
}); };
export var requestPasswordReset = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api.post("/".concat(BASE_PATH_ENTITY, "/password/request-reset"), {
                    data: data,
                    isV2: true,
                })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.data.data];
        }
    });
}); };
export var resetPassword = function (token, newPassword) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api.post("/".concat(BASE_PATH_ENTITY, "/password/reset"), {
                    data: { newPassword: newPassword },
                    isV2: true,
                    headers: { Authorization: "Bearer ".concat(token) },
                })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.data.data];
        }
    });
}); };
export var signOutUser = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, api.post("/".concat(BASE_PATH_ENTITY, "/sign-out"), {
                isV2: true,
            })];
    });
}); };
export var adminResetSmsCount = function (userId) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api.post("/".concat(BASE_PATH_ENTITY, "/admin-reset-sms-count?userId=").concat(userId), {
                    isV2: true,
                })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.data.data];
        }
    });
}); };
export var adminVerifyEmail = function (userId) {
    return api.post("/".concat(BASE_PATH_ENTITY, "/admin-confirm-email"), {
        data: { userId: userId },
        isV2: true,
    });
};
export var adminVerifyPhone = function (userId) {
    return api.post("/".concat(BASE_PATH_ENTITY, "/admin-confirm-phone"), {
        data: { userId: userId },
        isV2: true,
    });
};
export var signUp = function (data) {
    return api.post("/".concat(BASE_PATH_ENTITY, "/sign-up"), {
        data: data,
        isV2: true,
        authenticated: false,
    });
};
export var getUser = function () {
    return api.get("/users/me", {
        isV2: true,
    });
};
export var getAccessTokenFromEmail = function (userId, token) {
    return api.post("/".concat(BASE_PATH_ENTITY, "/request-access-token-from-email"), {
        data: { userId: userId, token: token },
        isV2: true,
    });
};
export var getTac = function (locale, platform, brokerId) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, api.get("/".concat(BASE_PATH_ENTITY, "/brokers/").concat(brokerId || CONFIG.RENTIO_BROKER_ID, "/tac/").concat(platform, "/").concat(locale), {
                isV2: true,
            })];
    });
}); };
export var getTacById = function (tacId) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, api.get("/".concat(BASE_PATH_ENTITY, "/tac/").concat(tacId), {
                isV2: true,
            })];
    });
}); };
export var updateUser = function (data) {
    return api.put("/".concat(BASE_PATH_ENTITY, "/users/me"), {
        data: data,
        isV2: true,
    });
};
export var updateUserById = function (id, data) {
    return api.patch("/users/".concat(id), {
        data: data,
        isV2: true,
    });
};
export var removeProfile = function () {
    return api.delete("/".concat(BASE_PATH_ENTITY, "/users/me/application/profile"), {
        isV2: true,
    });
};
